module.exports = __webpack_public_path__ + "img/input-textarea-icon.c91b7b4d.svg";